import { render, staticRenderFns } from "./custoMersmanage.vue?vue&type=template&id=2a37c716&scoped=true"
import script from "./custoMersmanage.vue?vue&type=script&lang=js"
export * from "./custoMersmanage.vue?vue&type=script&lang=js"
import style0 from "./custoMersmanage.vue?vue&type=style&index=0&id=2a37c716&prod&lang=less"
import style1 from "./custoMersmanage.vue?vue&type=style&index=1&id=2a37c716&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a37c716",
  null
  
)

export default component.exports